import { ReactNode } from "react";
import './input-number.css'
import TextInput from "./input-text.tsx";

export default function NumberInput (props: {
	label?: string,
	value: number,
  step: number,
  min?: number,
  max?: number,
  placeholder?:number,
  unit?: string,
  disabled?: boolean,
  infoButton?: ReactNode,
  onChange: (value: number) => void,
  onBlur?: () => void,
  validate?: (value: string) => Promise<boolean>, 
}){

  return <TextInput infoButton={props.infoButton} type="number" onBlur={props.onBlur} step={props.step} postfix={props.unit} label={props.label} value={props.value ? props.value.toString() : ""} placeholder={props.placeholder ? props.placeholder.toString() : ""}  disabled={props.disabled} onChange={(v)=>{
    props.onChange(Math.max(0, parseFloat(v || "0")));
  }} 
  validate={props.validate}/>
}
